import dbList from "../DBList.json";
import fetchWithTimeout from "./fetchWithTimeout";

const {
    api_server,
    trial_license
} = dbList.server;

export async function FetchTrialLicense() {
    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}/all/comp`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*"
        }
    });

    if (httpRes.status === 401) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function GetTrialLicense(ALicn) {
    const {
        companyName,
        productID
    } = ALicn;

    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}/get/${companyName}/${productID}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}

export async function UpdateTrialLicense(ALicn) {
    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: { 
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify(ALicn)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }
}

export async function ConvertToNonTrial(ALicn) {
    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}/convert`, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify(ALicn)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }
}

export async function DeleteTrialLicense(AID) {
    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}/${AID}`, {
        method: "DELETE",
        mode: "cors",
        credentials: "include",
        headers: { "accept": "*/*" }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }
}

export async function AddTrialLicense(ALicn) {
    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}`, {
        method: "PUT",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*",
            "content-type": "application/json"
        },
        body: JSON.stringify(ALicn)
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }
}

export async function GetCompanyInfo(ACompanyName) {
    const httpRes = await fetchWithTimeout(`${api_server}${trial_license}/get/${ACompanyName}`, {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
            "accept": "*/*"
        }
    });

    if (httpRes.status === 401) {
        // logout user
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    } else if (httpRes.status !== 200) {
        throw {
            status: httpRes.status,
            message: await httpRes.text()
        };
    }

    const result = await httpRes.json();

    if (result.status !== undefined && result.message !== undefined) {
        throw {
            status: 200,
            message: result.message
        };
    }

    return result;
}
